import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export enum PlatformType {
  SHOPIFY = "shopify",
  COMMENTSOLD = "commentsold",
}

export const getEnabledPlatforms = {
  name: "getEnabledPlatforms" as const,
  input: z.null(),
  output: z.array(createEnum(PlatformType)),
};
